import PageHeaderRoot from './PageHeaderRoot';

const PageHeaderSearch = () => {
  return <PageHeaderRoot variant="standard" maxWidth="lg" />;
};

export default PageHeaderSearch;
